import React, { useState } from "react";
import { ChevronLeft, ChevronRight, VideoIcon } from "lucide-react";

const MediaCarousel: React.FC<{ items: Array<{ url: string; isVideo: boolean }> }> = ({ items }) => {
  const [idx, setIdx] = useState(0);
  if (!items.length) return null;

  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIdx(i => (i - 1 + items.length) % items.length);
  };

  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIdx(i => (i + 1) % items.length);
  };

  return (
    <div className="relative h-56 overflow-hidden border-b border-slate-100 bg-slate-900 group/carousel">
      {items[idx].isVideo ? (
        <div className="w-full h-full flex items-center justify-center text-white/60">
          <VideoIcon size={40} />
        </div>
      ) : (
        <img
          src={items[idx].url}
          alt=""
          className="w-full h-full object-cover transition-transform duration-700 group-hover/carousel:scale-110"
        />
      )}

      {items.length > 1 && (
        <>
          <button onClick={prev} className="absolute left-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center opacity-0 group-hover/carousel:opacity-100 transition-all hover:bg-white/40">
            <ChevronLeft size={18} />
          </button>

          <button onClick={next} className="absolute right-3 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/20 backdrop-blur-md text-white flex items-center justify-center opacity-0 group-hover/carousel:opacity-100 transition-all hover:bg-white/40">
            <ChevronRight size={18} />
          </button>

          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
            {items.map((_, i) => (
              <div
                key={i}
                className={`h-1.5 rounded-full transition-all ${
                  i === idx ? "bg-white w-4" : "bg-white/40 w-1.5"
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MediaCarousel;